// extracted by mini-css-extract-plugin
module.exports = {"fieldEstatus":"styles_fieldEstatus__3VX8m","trashCan":"styles_trashCan__1pggj"};